import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const faqs = [
  {
    category: "General Information",
    questions: [
      {
        q: "What is Community Portal?",
        a: "Community Portal is a comprehensive digital platform designed for residential communities and HOAs. It includes tools for communication, resource management, local commerce, and more—all in a secure, verified environment."
      },
      {
        q: "Who can use Community Portal?",
        a: "Any residential community, including HOA-managed neighborhoods, condos, and apartment complexes. Both residents and administrative staff benefit."
      },
      {
        q: "How is Community Portal different from social media groups or existing apps?",
        a: "Unlike generic apps, Community Portal is designed specifically for communities. It's verified, secure, and brings all essential functions into one place."
      },
      {
        q: "Is Community Portal available on mobile devices?",
        a: "Yes, it's available on both iOS and Android, as well as on the web."
      },
      {
        q: "How much does Community Portal cost?",
        a: "Pricing is based on community size and features. For residents, it's included in community membership."
      }
    ]
  },
  {
    category: "Account Management & Security",
    questions: [
      {
        q: "How do I sign up for Community Portal?",
        a: "Download the app or visit our website, provide your details, and verify through your HOA or peer verification."
      },
      {
        q: "How does Community Portal verify that users actually live in the community?",
        a: "Verification is multi-layered, including HOA record checks, peer verification, and address validation."
      },
      {
        q: "What personal information is visible to other community members?",
        a: "By default, only name and address. You can choose to share more. Admins access contact info for communication."
      },
      {
        q: "How does Community Portal protect my privacy and data?",
        a: "We use encryption, secure authentication, multi-tenant isolation, and never sell personal data."
      }
    ]
  },
  // Additional categories would follow here for brevity. Use the same pattern.
];

const FaqPage = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setOpenQuestion(prev => (prev === key ? null : key));
  };

  return (
    <>
      <Navbar />
      <div className="px-6 py-12 max-w-5xl mx-auto text-gray-800">
        <h1 className="text-4xl font-bold text-center mb-4 bg-gradient-to-r from-slate-400 via-zinc-400 to-stone-800 text-transparent bg-clip-text">
          Frequently Asked Questions
        </h1>
        <p className="text-center text-gray-600 mb-12">Find answers to the most common questions about Community Portal</p>

        {faqs.map((section, catIdx) => (
          <div key={section.category} className="mb-10">
            <h2 className="text-2xl font-semibold text-indigo-600 mb-4 border-b pb-1">
              {section.category}
            </h2>
            <div className="space-y-4">
              {section.questions.map((item, qIdx) => {
                const key = `${catIdx}-${qIdx}`;
                const isOpen = openQuestion === key;
                return (
                  <div key={key} className="border rounded-md">
                    <button
                      onClick={() => toggleQuestion(catIdx, qIdx)}
                      className="w-full text-left p-4 flex justify-between items-center hover:bg-gray-50"
                    >
                      <span className="font-medium text-gray-800">{item.q}</span>
                      <span className="text-xl">{isOpen ? '-' : '+'}</span>
                    </button>
                    {isOpen && (
                      <div className="px-4 pb-4 text-gray-600">
                        {item.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
};

export default FaqPage;
